const endpoints = {
	//Tasks
	createProjectColumn: '/tasks/kanban/createProjectColumn',
	updateProjectColumn: '/tasks/kanban/updateProjectColumn',
	updateProjectColumnsPosition: '/tasks/kanban/updateProjectColumnsPosition',
	deleteProjectColumn: '/tasks/kanban/deleteProjectColumn',
	setTaskColumn: '/tasks/kanban/setTaskColumn',
	getProjectColumns: '/tasks/kanban/getProjectColumns',
	updateTaskColumn: '/tasks/kanban/updateTaskColumn',
	getProjectKanban: '/tasks/kanban/getProjectKanban',
}
export {endpoints}